export default __webpack_public_path__ + "img/bINVwuwH.ae62c1d3.svg";